import React from 'react';
import { motion } from 'framer-motion';
import BuyButtons from '../components/BuyButtons';
import * as FiIcons from 'react-icons/fi';

const { FiStar } = FiIcons;

const reviews = [
  { name: 'Sarah M.', location: 'New York, USA', rating: 5, date: 'March 2025', platform: 'Amazon', text: 'I finally understand why my husband shuts down during arguments. This book didn\'t just help our marriage — it saved it. The chapter on "The Burden of Provision" broke my heart open in the best way. I wish I had read it years ago.' },
  { name: 'Elena R.', location: 'London, UK', rating: 5, date: 'February 2025', platform: 'Amazon', text: 'Andrei writes with such empathy and clarity. The chapter on "The Language of Action" completely reframed how I see my partner. I stopped waiting for him to say the right words and started seeing the love in everything he did. Extraordinary book.' },
  { name: 'Christine L.', location: 'Toronto, Canada', rating: 5, date: 'April 2025', platform: 'Amazon', text: 'I was skeptical of relationship books, but this one is different. It\'s practical, honest, and deeply compassionate. I\'ve already gifted it to three friends. Each truth builds on the last — by the end, you have a completely new framework for love.' },
  { name: 'Maria T.', location: 'Sydney, Australia', rating: 5, date: 'March 2025', platform: 'Author Website', text: 'Reading this felt like someone finally gave me the manual I\'d been searching for. The insights are profound yet accessible. I highlighted something on almost every page. A must-read for any woman who loves or wants to love a good man.' },
  { name: 'Jessica P.', location: 'Chicago, USA', rating: 5, date: 'January 2025', platform: 'Amazon', text: 'I\'ve been in therapy for two years trying to understand my relationship. This book did in 8 chapters what two years of therapy hadn\'t. Not because therapy is wrong — but because this book gave me the specific language and framework I was missing.' },
  { name: 'Nathalie B.', location: 'Paris, France', rating: 5, date: 'April 2025', platform: 'Amazon', text: 'I read this in French translation and the power of the writing still comes through completely. The chapter on "Space & Connection" is worth the price of the book alone. It resolved a conflict my partner and I had been having for two years.' },
];

const ReviewsPage = () => (
  <div className="pt-28">
    <section className="py-16 bg-gradient-to-b from-amber-50 to-white text-center">
      <div className="max-w-3xl mx-auto px-6">
        <span className="text-brand-accent font-semibold tracking-widest uppercase text-xs">Reader Reviews</span>
        <h1 className="text-5xl font-serif font-bold text-brand-dark mt-3 mb-5">
          What Readers Are Saying
        </h1>
        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="flex">{[...Array(5)].map((_, i) => <FiStar key={i} className="text-amber-400 fill-amber-400" size={24} />)}</div>
          <span className="text-3xl font-serif font-bold text-brand-dark">4.9</span>
          <span className="text-slate-400">/ 5.0 average</span>
        </div>
        <p className="text-slate-500">From readers worldwide across all platforms</p>
      </div>
    </section>

    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="bg-slate-50 rounded-2xl p-7 border border-slate-100 flex flex-col"
            >
              <div className="flex mb-3">
                {[...Array(r.rating)].map((_, j) => <FiStar key={j} className="text-amber-400 fill-amber-400" size={14} />)}
              </div>
              <p className="text-slate-700 leading-relaxed italic flex-1 mb-5">"{r.text}"</p>
              <div className="flex items-center justify-between pt-4 border-t border-slate-200">
                <div>
                  <div className="font-semibold text-brand-dark text-sm">{r.name}</div>
                  <div className="text-xs text-slate-400">{r.location}</div>
                </div>
                <div className="text-right">
                  <div className="text-xs text-brand-accent font-medium">{r.platform}</div>
                  <div className="text-xs text-slate-400">{r.date}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-20 bg-slate-900 text-white text-center">
      <div className="max-w-2xl mx-auto px-6">
        <h2 className="text-4xl font-serif font-bold mb-5">Join Thousands of Readers</h2>
        <p className="text-slate-400 text-lg mb-10">Your transformation starts with the first chapter.</p>
        <BuyButtons />
      </div>
    </section>
  </div>
);

export default ReviewsPage;